// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QZAF","type":"styles_type__1d0bf","choices":"styles_choices__3v1gd"};